const LinkedInIcon = ({
  fill = undefined,
  filled = false,
  size = undefined,
  height = undefined,
  width = undefined,
  label = "LinkedInIcon",
  ...props
}) => {
  return (
    <svg
      fill={filled ? fill : "none"}
      {...props}
      viewBox="0 0 45 45"
      focusable="false"
      stroke="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path
        fill="#FDF9ED"
        d="M41.669 0H3.322C1.485 0 0 1.45 0 3.243v38.505C0 43.541 1.485 45 3.322 45H41.67C43.506 45 45 43.541 45 41.757V3.243C45 1.45 43.506 0 41.669 0zM13.35 38.347H6.67v-21.48h6.68v21.48zM10.01 13.94a3.87 3.87 0 01-3.876-3.868 3.87 3.87 0 013.876-3.867 3.867 3.867 0 010 7.735zm28.336 24.407h-6.671V27.905c0-2.487-.044-5.695-3.472-5.695-3.472 0-3.999 2.716-3.999 5.52v10.617h-6.662v-21.48h6.398v2.935h.088c.888-1.688 3.068-3.472 6.31-3.472 6.76 0 8.008 4.447 8.008 10.23v11.787z"
      ></path>
    </svg>
  );
};

export default LinkedInIcon;
